const SESSION_KEY = "journey_session_id";
const SESSION_START_KEY = "journey_session_start";

function generateUUID() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const SessionManager = {
  getSessionId() {
    return sessionStorage.getItem(SESSION_KEY);
  },

  startSession() {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem(SESSION_KEY, sessionId);
      sessionStorage.setItem(SESSION_START_KEY, new Date().toISOString());
    }
    return sessionId;
  },

  endSession() {
    const sessionId = sessionStorage.getItem(SESSION_KEY);
    const startTime = sessionStorage.getItem(SESSION_START_KEY);

    let durationSeconds = null;
    if (startTime) {
      durationSeconds = Math.round(
        (Date.now() - new Date(startTime).getTime()) / 1000
      );
    }

    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(SESSION_START_KEY);

    return { sessionId, durationSeconds };
  },

  isActive() {
    return !!sessionStorage.getItem(SESSION_KEY);
  },

  ensureSession() {
    const token = localStorage.getItem("accessToken");
    if (token && !this.getSessionId()) {
      return this.startSession();
    }
    return this.getSessionId();
  },
};

export default SessionManager;
